'use client';

import { lazy, Suspense, useState } from 'react';
import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@eliadmin/core/src/components/ui/dialog';
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export type { Step, TourFormValues } from './tour-reservation-form-runtime';

const ReservationRuntime = lazy(() =>
  import('./tour-reservation-form-runtime').then(module => ({
    default: module.TourReservationFormRuntime,
  })),
);

export function TourReservationForm(props: { tour: TravelAgencyTour; tourId: number; price: any }) {
  const { t } = useTranslations();
  const isDesktop = useBreakpoint('sm');
  const [open, setOpen] = useState(false);
  const [activated, setActivated] = useState(false);
  const Wrapper = isDesktop ? Dialog : Sheet;
  const Trigger = isDesktop ? DialogTrigger : SheetTrigger;
  const Content = isDesktop ? DialogContent : SheetContent;
  const Title = isDesktop ? DialogTitle : SheetTitle;

  return (
    <Wrapper
      open={open}
      onOpenChange={next => {
        if (next) setActivated(true);
        setOpen(next);
      }}
    >
      <Trigger className="h-12 w-full rounded-[16px] bg-primary px-6 py-2 text-sm font-medium text-white">
        {t('text3978')}
      </Trigger>
      {/* Keep the runtime outside Content: closing the portal must not reset its form state. */}
      {activated && (
        <Suspense
          fallback={
            <Content side="bottom" className="bg-[#F6F6F6] p-6 sm:rounded-[32px]">
              <Title>{t('text3979')}</Title>
              <div
                role="status"
                aria-label={t('text3979')}
                aria-busy="true"
                className="h-24 animate-pulse rounded-xl bg-primary/10"
              />
            </Content>
          }
        >
          <ReservationRuntime {...props} isDesktop={isDesktop} />
        </Suspense>
      )}
    </Wrapper>
  );
}

TourReservationForm.id = 'TOUR_RESERVATION_FORM';
